<template>
  <div>
    <div class="item" v-for="(item, index) in list" :key="index">
      <div class="item-pics">
        <Carousel height="344px" :list="item.urlList" :parentItem="item" type="hotel" />
      </div>
      <div class="item-content">
        <div class="item-head">
          <div class="tag" v-if="item.hotelType_translate">{{ item.hotelType_translate }}</div>
          <Title :text="item.houseResourcesName" />
        </div>
        <!-- 酒店 -->
        <ul class="item-rooms" v-if="item.hotelType == 1">
          <li v-for="room in item.roomTypes" :key="room.houseResourcesId">
            <div class="title">{{ room.roomTypeName_translate || room.roomTypeName }}</div>
            <div class="room-intro">
              <div class="user" v-if="room.maxPersons">{{ room.maxPersons }}</div>
              <div class="bed" v-if="room.totalBeds">{{ room.totalBeds }}</div>
              <div class="bathroom" v-if="room.bathRooms">{{ room.bathRooms }}</div>
            </div>
          </li>
        </ul>
        <!-- 民宿 -->
        <template v-else>
          <ul class="item-rooms" style="height: 132px">
            <li v-for="room in item.accommodationRooms" :key="room.id">
              <div class="title">{{ room.roomNo }}</div>
            </li>
          </ul>
          <div class="room-intro">
            <div class="user" v-if="item.maxPersons">{{ item.maxPersons }}</div>
            <div class="sofa" v-if="item.livingRoom">{{ item.livingRoom }}</div>
            <div class="kitchen" v-if="item.kitchen">{{ item.kitchen }}</div>
            <div class="bed" v-if="item.totalBeds">{{ item.totalBeds }}</div>
            <div class="bathroom" v-if="item.bathRooms">{{ item.bathRooms }}</div>
            <div class="toilet" v-if="item.toilets">{{ item.toilets }}</div>
          </div>
        </template>

        <div class="item-footer">
          <div class="price">
            <template v-if="item.minPrice">{{ item.currency }} {{ item.minPrice }} ~</template>
          </div>
          <div class="btn btn-theme" @click="toBook(item)">{{ ts('BOOK NOW')['BOOK NOW'] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Carousel from '@/components/Carousel.vue'
import Title from '@/components/Title.vue'

export default {
  name: 'HotelItem',
  props: ['list', 'date'],
  mixins: [LanguagePackage],
  data() {
    return {}
  },
  components: {
    Carousel,
    Title,
  },
  created() {},
  methods: {
    // 预定酒店
    toBook(room) {
      this.$router.push({ name: 'Hotel', params: { id: room.houseResourcesId }, query: { date: this.date } })
    },
  },
}
</script>
